module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayclear@2-e5ff607a57234f4d7027cf847f06b5d6.png";